<template>
  <div
    class="dsfa-sc-area-informant-table-wrap dsfa-sc-area-informant-table-dialog"
    style="height: 600px"
  >
    <el-table
      height="100%"
      :data="list"
      style="width: 100%"
      :default-sort="{ prop: 'date', order: 'descending' }"
    >
      <el-table-column
        prop="area"
        label="区域"
        class-name="dsfa-sc-area-informant-table-dialog-area"
      >
      </el-table-column>
      <el-table-column
        prop="data"
        label="数量"
        sortable
        align="center"
        header-align="center"
        width="190px"
      >
      </el-table-column>
      <el-table-column label="同比增长" align="center" header-align="center" width="280px">
        <template slot-scope="scope">
          <div class="dsfa-sc-tbody-td-data">
            {{ scope.row.up1.data }}<span class="unit">%</span>
            <img
              src="~_statistics-cloud/assets/styles/img/leaderCockpit/icon-down.png"
              alt=""
              v-if="scope.row.up1.data < 0"
            />
            <img
              src="~_statistics-cloud/assets/styles/img/leaderCockpit/icon-up.png"
              alt=""
              v-if="scope.row.up1.data > 0"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column label="同比增长"  align="center" header-align="center"  width="100px">
        <template slot-scope="scope">
          <div class="dsfa-sc-tbody-td-data">
            {{ scope.row.up2.data }}<span class="unit">%</span>
            <img
              src="~_statistics-cloud/assets/styles/img/leaderCockpit/icon-down.png"
              alt=""
              v-if="scope.row.up2.data < 0"
            />
            <img
              src="~_statistics-cloud/assets/styles/img/leaderCockpit/icon-up.png"
              alt=""
              v-if="scope.row.up2.data > 0"
            />
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "DSFSCAreaInformantTable",
  data() {
    return {
      list: [],
      isSorted: false, // 是否排序过
      isUpSort: true, // 是否为升序
    };
  },
  created() {
    console.log(this.utils.randomNum(-20, 20));
    this.$http.get("/static/data/dsf.scareainformanttable.json").then(({ data }) => {
      let list = data;
      for (let item of list) {
        let up1 = this.getUpNumber();
        let up2 = this.getUpNumber();
        console.log(up1, up2);
        let areaData = {
          area: item,
          data: this.utils.randomNum(2000, 12000),
          up1: {
            data: up1,
            isUp: true,
          },
          up2: {
            data: up2,
            isUp: true,
          },
        };
        this.list.push(areaData);
      }
    });
  },
  methods: {
    getUpNumber() {
      let number = this.utils.randomNum(-20, 20);
      if (!number) {
        return this.getUpNumber();
      } else {
        return number;
      }
    },
  },
};
</script>

<style></style>
